export enum PlanType {
    Recruitment = "Recruitment",
    Onboarding = "Onboarding",
    FullHiring = "FullHiring",
}
